import { useContext, useState } from 'react';
import { Save as SaveIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import FieldContext from '../FieldContext';
import ModelsContext from '../../../../ModelsContext';
import AdditionalConfigStateContext from '../AdditionalConfigStateContext';
import useApi from '@/lib/api/useApi';
import { type EditorFieldWithoutRelations } from '@/lib/types';
import { Button } from '@mui/material';
import SelectedModelIdContext from '../../../../SelectedModelIdContext';

const SaveAdditionalConfigChangesButton = () => {
  const api = useApi();

  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);

  const { field } = useContext(FieldContext);
  const [additionalConfig, , , reenableAdditionalConfigSync] = useContext(
    AdditionalConfigStateContext,
  );

  const [saving, setSaving] = useState(false);

  const saveAdditionalConfigChanges = async (): Promise<void> => {
    setSaving(true);

    const updatedField = await api.put<EditorFieldWithoutRelations>(
      `editor/challenge-model/fields/${field!.id}/additional-config`,
      {
        additionalConfig: JSON.stringify(additionalConfig),
      },
    );

    setSaving(false);

    setModels(models => {
      models[selectedModelId].fields[field!.id] = {
        ...models[selectedModelId].fields[field!.id],
        ...updatedField,
      };
    });

    reenableAdditionalConfigSync();
  };

  return (
    <Button
      variant="contained"
      size="small"
      onClick={saveAdditionalConfigChanges}
      startIcon={<SaveIcon />}
      loadingPosition="start"
      loading={saving}
      disableElevation
    >
      <FormattedMessage id="editor.challenge_model_editor.field_editor.save_button" />
    </Button>
  );
};

export default SaveAdditionalConfigChangesButton;
